var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-block relative",
    staticStyle: {
      "height": "36px"
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.throwErrorStatus
    }
  }), _vm.confirmMsg ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "300",
      "persistent": "",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.confirmMsg = null;
      }
    }
  }, [_c('v-card', {
    staticClass: "pt-4"
  }, [_c('v-card-title', {
    staticClass: "pt-0"
  }, [_vm._v("Are you sure?")]), _c('v-card-text', {
    staticClass: "break-word",
    domProps: {
      "innerHTML": _vm._s(_vm.confirmMsg)
    }
  }), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.skipDuplicateCheck = false;
        _vm.confirmMsg = null;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    staticClass: "relative overflow-hidden",
    attrs: {
      "text": "",
      "loading": _vm.attachPayPalButtonsStatus.pending || _vm.orderPending
    }
  }, [_vm._v(" Continue "), _c('div', {
    ref: "btn",
    staticClass: "absolute-fill my-n1 mx-n2",
    staticStyle: {
      "opacity": "0.001"
    },
    attrs: {
      "id": _vm.btnId
    }
  })])], 1)], 1)], 1) : _vm._e(), _c('v-btn', {
    staticClass: "absolute-fill",
    staticStyle: {
      "z-index": "1",
      "background": "rgb(254,195,73)"
    },
    attrs: {
      "loading": ""
    }
  }), _vm.attachPayPalButtonsStatus.pending || _vm.orderPending ? _c('v-btn', {
    staticClass: "absolute-fill",
    staticStyle: {
      "z-index": "1001",
      "background": "none",
      "pointer-events": "none"
    },
    attrs: {
      "elevation": "0"
    }
  }) : _vm._e(), !_vm.confirmMsg ? _c('div', {
    ref: "btn",
    attrs: {
      "id": _vm.btnId
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }